import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { toggleLoadingOverlay } from './product-page';
export var InvoiceModal = /*#__PURE__*/function () {
  // html måste vara en sträng
  function InvoiceModal(id, productID, html) {
    _classCallCheck(this, InvoiceModal);
    _defineProperty(this, "id", '');
    _defineProperty(this, "html", null);
    _defineProperty(this, "DOM", {
      el: null,
      form: null,
      errorContainer: null
    });
    _defineProperty(this, "formEndpoint", '');
    _defineProperty(this, "listeners", {
      closeEvent: null,
      submitEvent: null
    });
    this.elementId = id;
    this.productID = productID;
    this.html = JSON.parse(html);
    this.init();
  }
  _createClass(InvoiceModal, [{
    key: "init",
    value: function init() {
      var invoiceModal = document.createElement('div');
      invoiceModal.id = this.elementId;
      invoiceModal.innerHTML = this.html;
      this.DOM.el = invoiceModal;
      this.DOM.form = this.DOM.el.querySelector('form');
      this.DOM.overlay = this.DOM.el.querySelector('.wl-invoice-modal__overlay');
      this.DOM.closeBtns = _toConsumableArray(this.DOM.el.querySelectorAll('.wl-close-btn'));
      this.DOM.errorContainer = this.DOM.el.querySelector('.invoice-modal__error-container');
      this.addListeners();
      document.body.append(this.DOM.el);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      this.listeners.closeEvent = this.closeModal.bind(this);
      this.listeners.submitEvent = this.submitEvent.bind(this);
      var _iterator = _createForOfIteratorHelper(this.DOM.closeBtns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var closeBtn = _step.value;
          closeBtn.addEventListener('click', this.listeners.closeEvent);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.DOM.overlay.addEventListener('click', this.listeners.closeEvent);
      this.DOM.form.addEventListener('submit', this.listeners.submitEvent);
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this = this;
      this.DOM.el.classList.add('-is-being-removed');
      setTimeout(function () {
        _this.tearDown();
      }, 500);
    }
  }, {
    key: "submitEvent",
    value: function submitEvent(e) {
      var _this2 = this;
      e.preventDefault();
      toggleLoadingOverlay();
      var formData = new FormData(this.DOM.form);
      formData.append('action', 'submit_invoice_form');
      $.ajax({
        contentType: false,
        processData: false,
        url: ajax_handler.ajaxurl,
        data: formData,
        type: 'POST',
        success: function success(response) {
          toggleLoadingOverlay(true);
          if (response.success) _this2.handleSuccessfulFormSubmit();else _this2.handleErrorSubmit(response.data);
        },
        error: function error(err) {
          toggleLoadingOverlay(true);
          console.error(err);
        }
      });
    }
  }, {
    key: "handleErrorSubmit",
    value: function handleErrorSubmit(responseError) {
      this.DOM.errorContainer.innerHTML = responseError;
    }
  }, {
    key: "handleSuccessfulFormSubmit",
    value: function handleSuccessfulFormSubmit() {
      var _this3 = this;
      this.DOM.el.classList.add('-form-submitted');
      setTimeout(function () {
        _this3.addTextToInvoiceBtn();
        _this3.tearDown();
      }, 500);
    }
  }, {
    key: "addTextToInvoiceBtn",
    value: function addTextToInvoiceBtn() {
      var html = '<span>Offertförfrågan skickad! <img src="' + page_urls.site_uri + '/img/check.svg" alt="slider nästa" /></span>';
      var isOnProductPage = document.body.classList.contains('single-product');
      var buttonToAddTextTo = isOnProductPage ? document.getElementById('request-invoice-btn') : document.querySelector(".product[data-product-id=\"".concat(this.productID, "\"] .wl-request-invoice-btn"));
      if (!buttonToAddTextTo) return;
      buttonToAddTextTo.innerHTML = html;
    }
  }, {
    key: "tearDown",
    value: function tearDown() {
      var _iterator2 = _createForOfIteratorHelper(this.DOM.closeBtns),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var closeBtn = _step2.value;
          closeBtn.removeEventListener('click', this.listeners.closeEvent);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.DOM.overlay.removeEventListener('click', this.listeners.closeEvent);
      this.DOM.form.removeEventListener('submit', this.listeners.submitEvent);
      this.DOM.el.remove();
    }
  }]);
  return InvoiceModal;
}();